import { useId } from "react";
import { X } from "lucide-react";
import useDialogFocus from "@/components/ui/useDialogFocus";

/** A modal dialog (`drawer` makes it a side panel). Escape closes it, Tab stays inside, focus returns to what opened it, and it
 * is named by its title. Render it only while open. */
export default function Dialog({ title, onClose, children, footer, size = "md", drawer = false, label }) {
  const ref = useDialogFocus(true, onClose);
  const id = useId();
  const widths = { sm: "max-w-sm", md: "max-w-lg", lg: "max-w-2xl", xl: "max-w-4xl" };
  return (
    <div className={`fixed inset-0 z-[60] flex ${drawer ? "justify-end" : "items-center justify-center p-4"}`}>
      <button type="button" aria-label="Close" tabIndex={-1} className="absolute inset-0 bg-[var(--color-navy)]/50" onClick={onClose} />
      <div ref={ref} role="dialog" aria-modal="true" aria-labelledby={title ? id : undefined} aria-label={title ? undefined : label} tabIndex={-1}
           className={`relative w-full ${widths[size] || widths.md} bg-[var(--color-surface)] shadow-[var(--shadow-pop)] flex flex-col ${drawer ? "h-full" : "max-h-[90vh] rounded-[var(--radius-lg)]"}`}>
        {title && (
          <div className="flex items-center justify-between gap-3 px-5 py-4 border-b border-[var(--color-border)]">
            <h2 id={id} className="font-heading font-semibold text-[var(--color-navy)]">{title}</h2>
            <button type="button" onClick={onClose} aria-label="Close" className="p-2 -mr-2 rounded hover:bg-[var(--color-surface-muted)]"><X size={18} /></button>
          </div>
        )}
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-[var(--color-border)] flex flex-wrap justify-end gap-2">{footer}</div>}
      </div>
    </div>
  );
}
